import React from 'react';
import { Link } from 'react-router-dom';
import { Fuel, MapPin, Phone, Mail, Facebook, Twitter, Linkedin, Instagram } from 'lucide-react';
import { companyInfo } from '../mock';

export const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-gray-900 text-gray-300">
      {/* Main Footer */}
      <div className="max-w-7xl mx-auto px-6 py-16">
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-12">
          {/* Company Info */}
          <div>
            <Link to="/" className="flex items-center gap-3 mb-6 group">
              <img 
                src="/logo.jpg" 
                alt="Green Source Fuels" 
                className="h-14 w-14 object-contain group-hover:scale-110 transition-all duration-300 bg-white rounded-lg p-1"
              />
              <div>
                <div className="text-lg font-bold text-white">Green Source Fuels</div>
                <div className="text-xs text-emerald-400">Powering Africa</div>
              </div>
            </Link>
            <p className="text-sm leading-relaxed mb-4">
              Level 1 B-BBEE certified wholesale diesel supplier serving Southern Africa's logistics, mining, and farming industries.
            </p>
            <div className="flex gap-3">
              <a href="#" className="h-10 w-10 rounded-full bg-gray-800 hover:bg-emerald-600 flex items-center justify-center transition-all duration-300 hover:scale-110">
                <Facebook className="h-4 w-4" />
              </a>
              <a href="#" className="h-10 w-10 rounded-full bg-gray-800 hover:bg-emerald-600 flex items-center justify-center transition-all duration-300 hover:scale-110">
                <Twitter className="h-4 w-4" />
              </a>
              <a href="#" className="h-10 w-10 rounded-full bg-gray-800 hover:bg-emerald-600 flex items-center justify-center transition-all duration-300 hover:scale-110">
                <Linkedin className="h-4 w-4" />
              </a>
              <a href="#" className="h-10 w-10 rounded-full bg-gray-800 hover:bg-emerald-600 flex items-center justify-center transition-all duration-300 hover:scale-110">
                <Instagram className="h-4 w-4" />
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-white font-bold text-lg mb-6">Quick Links</h3>
            <ul className="space-y-3">
              <li>
                <Link to="/" className="hover:text-emerald-400 transition-colors duration-300">Home</Link>
              </li>
              <li>
                <Link to="/about" className="hover:text-emerald-400 transition-colors duration-300">About Us</Link>
              </li>
              <li>
                <Link to="/services" className="hover:text-emerald-400 transition-colors duration-300">Products & Services</Link>
              </li>
              <li>
                <Link to="/industries" className="hover:text-emerald-400 transition-colors duration-300">Industries</Link>
              </li>
              <li>
                <Link to="/trade-history" className="hover:text-emerald-400 transition-colors duration-300">Trade History</Link>
              </li>
              <li>
                <Link to="/contact" className="hover:text-emerald-400 transition-colors duration-300">Contact</Link>
              </li>
            </ul>
          </div>

          {/* Services */}
          <div>
            <h3 className="text-white font-bold text-lg mb-6">Our Services</h3>
            <ul className="space-y-3">
              <li className="hover:text-emerald-400 transition-colors duration-300">Wholesale Fuel Supply</li>
              <li className="hover:text-emerald-400 transition-colors duration-300">Transportation & Logistics</li>
              <li className="hover:text-emerald-400 transition-colors duration-300">Fuel Storage Solutions</li>
              <li className="hover:text-emerald-400 transition-colors duration-300">Storage Facility Setup</li>
              <li className="hover:text-emerald-400 transition-colors duration-300">Compliance Consulting</li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h3 className="text-white font-bold text-lg mb-6">Contact Us</h3>
            <ul className="space-y-4">
              <li className="flex items-start gap-3">
                <MapPin className="h-5 w-5 text-emerald-400 flex-shrink-0 mt-0.5" />
                <div className="text-sm space-y-2">
                  {companyInfo.addresses.map((addr, idx) => (
                    <div key={idx}>
                      <div className="font-semibold text-emerald-300">{addr.label}</div>
                      <div>{addr.street}{addr.area ? `, ${addr.area}` : ''}, {addr.city}, {addr.province}{addr.postalCode ? ` ${addr.postalCode}` : ''}</div>
                    </div>
                  ))}
                </div>
              </li>
              <li className="flex items-start gap-3">
                <Phone className="h-5 w-5 text-emerald-400 flex-shrink-0 mt-0.5" />
                <div className="text-sm">
                  {companyInfo.phone.map((num, idx) => (
                    <div key={idx}>{num}</div>
                  ))}
                </div>
              </li>
              <li className="flex items-start gap-3">
                <Mail className="h-5 w-5 text-emerald-400 flex-shrink-0 mt-0.5" />
                <span className="text-sm">{companyInfo.email}</span>
              </li>
            </ul>
          </div>
        </div>
      </div>

      {/* Bottom Bar */}
      <div className="border-t border-gray-800">
        <div className="max-w-7xl mx-auto px-6 py-6">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            <p className="text-sm text-gray-400">
              © {currentYear} Green Source Fuels. All rights reserved.
            </p>
            <div className="flex gap-6 text-sm">
              <a href="#" className="text-gray-400 hover:text-emerald-400 transition-colors duration-300">Privacy Policy</a>
              <a href="#" className="text-gray-400 hover:text-emerald-400 transition-colors duration-300">Terms of Service</a>
              <a href="#" className="text-gray-400 hover:text-emerald-400 transition-colors duration-300">Cookie Policy</a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;